<template>
  <div v-if="toggled" class="action--modal" @click.self="emitToggle">
    <form class="tile action-form" @submit.prevent="submit">
      <p class="content__heading">New Service</p>
      <label class="action-form--label" for="service-name">
        Service Name:
        <input
          type="text"
          id="service-name"
          name="service-name"
          v-model="form.name"
          placeholder="New Service"
          :class="{'input--error': error.name}"
        />
      </label>
      <label class="action-form--label" for="type">
        Request Type:
        <select
          id="type"
          name="type"
          v-model="form.type"
          :class="{'input--error': error.type}"
        >
          <option v-for="type in types" :key="type.url" :value="type.url">{{type.url}}</option>
        </select>
      </label>
      <div class="flex__between">
        <span class="text__bold text__red" @click.prevent="emitToggle">Cancel</span>
        <button class="btn btn__small btn__green" @click.prevent="submit">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["toggled", "types"],
  data() {
    return {
      form: {
        name: "",
        type: ""
      },
      error: {
        name: false,
        type: false
      }
    };
  },
  methods: {
    ...mapActions(["startCreateService"]),
    emitToggle() {
      this.$emit("setNewToggled");
      this.error.name = false;
      this.error.type = false;
      return this.resetForm();
    },
    resetForm() {
      return (this.form.name = "");
    },
    async submit() {
      this.form.name === ""
        ? (this.error.name = true)
        : (this.error.name = false);
      this.form.type === ""
        ? (this.error.type = true)
        : (this.error.type = false);
      if (this.error.name || this.error.type) {
        return;
      }
      // submit form
      await this.startCreateService(this.form);
      this.emitToggle();
    }
  }
};
</script>

<style scoped lang="scss">
</style>